export const downloadBlob = (blob: Blob, filename: string): void => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
};

const normalizeFilenameSegment = (value: string): string => {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');
};

export const getReportDocxFilename = (patientName?: string, fallbackId?: string): string => {
    const normalizedPatientName = normalizeFilenameSegment(patientName || '');

    if (normalizedPatientName) {
        return `laudo_${normalizedPatientName}.docx`;
    }

    if (fallbackId) {
        return `laudo_${fallbackId}.docx`;
    }

    return 'laudo_sem_nome.docx';
};

export const getReportJsonFilename = (
    patientName?: string,
    fallbackId?: string,
    exportedAt: Date = new Date(),
): string => {
    const normalizedPatientName = normalizeFilenameSegment(patientName || '');
    const baseName = normalizedPatientName || fallbackId || 'sem_nome';
    const timestamp = exportedAt.toISOString().replace(/[.:]/g, '-');

    return `laudo_${baseName}_${timestamp}.json`;
};
